import { useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useGetNextState } from "../../hooks/useGetNextState";
import { ConnectLoading } from "./ConnectLoading";
import { analytics } from "../../analytics";
import { SESSION_STORAGE_KEYS, sessionStorageService } from "../../services/sessionStorage";

export function ConnectOAuth() {
  const { linkToken } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { getNextState } = useGetNextState(linkToken || "");
  const exchangeCodeOnce = useRef(false);

  useEffect(() => {
    if (analytics && analytics.page) {
      analytics.page("connect oauth");
    }
  }, []);

  const state = searchParams.get("state");

  // Trigger token exchange — the authorization code is stored server-side, not passed here
  useEffect(() => {
    const storedState = sessionStorageService.get(SESSION_STORAGE_KEYS.state);
    if (!state || storedState !== state) {
      navigate(`/${linkToken}/error?texture_error=oauth_state_mismatch`);
      return;
    }

    /**
     * Avoid multiple calls to exchange code.
     * This is primarily an issue that occurs with React strict mode
     * where useEffect is called twice.
     */
    if (exchangeCodeOnce.current) {
      return;
    }
    exchangeCodeOnce.current = true;

    getNextState("oauth:code", {
      type: "continue",
      data: {},
    });
  }, []);

  return <ConnectLoading />;
}
